/**
 * Fetch user role from users/{uid} safely. Use for routing and guards.
 * Avoids repeated reads by callers who need only role + onboardingCompleted.
 */

import { doc, getDoc } from 'firebase/firestore';
import { db } from './firebase';

export type UserRole = 'creator' | 'brand';

export interface UserRoleData {
  role: UserRole | 'influencer' | null;
  onboardingCompleted: boolean;
}

export async function getUserRole(uid: string): Promise<UserRoleData | null> {
  if (!uid) return null;
  try {
    const ref = doc(db, 'users', uid);
    const snap = await getDoc(ref);
    if (!snap.exists()) return null;
    const data = snap.data();
    const role = (data?.role ?? data?.userType) as string | undefined;
    const onboardingCompleted =
      data?.onboardingCompleted === true || data?.onboardingStatus === 'completed';
    if (process.env.NODE_ENV === 'development' && role) {
      console.log('[getUserRole]', uid, 'role:', role, 'onboardingCompleted:', onboardingCompleted);
    }
    return {
      role: role === 'creator' || role === 'influencer' || role === 'brand' ? role : null,
      onboardingCompleted,
    };
  } catch (err) {
    console.warn('[getUserRole] Failed to fetch:', err);
    return null;
  }
}
